var file_upload_viewer_default = {
  "fontElementMap": "CxPcb",
  "file_upload_container": "hybgw",
  "file_upload_link": "_1qo6M",
  "file_upload_error_container": "lvD06",
  "file_upload_file_info": "i9qf-",
  "file_upload_type_icon": "w-weh",
  "file_upload_status_icon_container": "AXTev",
  "file_upload_status_icon": "psorM",
  "file_upload_description": "gEfwt",
  "file_upload_name_container": "_3py6H",
  "file_upload_name": "VMXuy",
  "file_upload_extension": "ZbWwK",
  "file_loader_icon": "wz7FG",
  "file_upload_icon_frame": "KMLC0",
  "file_upload_icon_background": "CErfF"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
